// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:37:29

export default {
  "id": "stickman-prison-and-love",
  "slug": "stickman-prison-and-love",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/e3079cf2973e4960bf948fce7574e098-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/e3079cf2973e4960bf948fce7574e098/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Stickman Prison and Love",
      "description": "In Stickman Prison and Love, help Stickman escape from jail after a daring heist for love! With a mysterious package from his sweetheart, carefully choose your tools to plan his escape. Every decision shapes the twists of this story-driven adventure—can Stickman reunite with his true love?",
      "instructions": "Find a single, successful way to escape from prison.Use a computer mouse to control the game. If you have a mobile device, then use a stylus or a finger.",
      "genres": [
        "Adventure"
      ],
      "tags": [
        "escape",
        "point-and-click",
        "stickman",
        "story"
      ]
    },
    "zh-CN": {
      "title": "棍人监狱与爱",
      "description": "在《棍人监狱与爱》中，帮助棍人从监狱中逃脱，完成一场为了爱情的勇敢抢劫！在他的恋人寄来的神秘包裹的帮助下，仔细选择你的工具来计划他的逃脱。每个决定都会影响这个以故事为驱动的冒险的剧情转折——棍人能否与他的真爱团聚？",
      "instructions": "找到一种成功逃脱监狱的方法。使用鼠标控制游戏。如果你有移动设备，则使用笔尖或手指。",
      "genres": [
        "冒险"
      ],
      "tags": [
        "逃脱",
        "点触操作",
        "纸片人",
        "故事"
      ]
    },
    "zh-TW": {
      "title": "棍人監獄與愛",
      "description": "在《粘人監獄與愛情》中，幫助粘人小英雄逃出監獄，之後為了愛情進行一次驚險盜竊！透過從心儀之人那裡收到的神秘禮物，仔細選擇工具規劃他的逃亡計劃。每一個決定都塑造了這個以故事為導向冒險的轉折——粘人小英雄能夠與他真正的愛人重逢嗎？",
      "instructions": "尋找一個單一、成功的逃獄方法。使用滑鼠控制遊戲。如果您有行動裝置，則請使用筆或手指。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "逃離",
        "點選式操作",
        "木人",
        "故事"
      ]
    },
    "zh-HK": {
      "title": "Stickman 監獄愛情",
      "description": "在《樓梯人獄愛》中，幫助樓梯人逃出監獄，之後為愛展開一場膽戰心驚的搶劫！在情人送來的神秘禮物幫助下，謹慎選擇工具計劃他的逃亡計劃。每一個決定都會影響這個以故事為主導的冒險的轉折——樓梯人能否與真愛重逢？",
      "instructions": "尋找一個單一、成功的逃獄方法。使用滑鼠操控遊戲。如果你有行動裝置，則可使用筆或手指操控。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "逃離",
        "點擊選擇",
        "木人",
        "故事"
      ]
    },
    "ja": {
      "title": "スティックマン刑務所と愛",
      "description": "ストリックマン・プリズンと愛で、愛する人からの謎のパッケージを手に、大胆な愛の強盗の後、ストリックマンを刑務所から脱出させよう！脱出計画には慎重にツールを選び、物語を進める決定を下そう。どんな決定も物語の展開を形作る－ストリックマンは真の愛と再会できるか？",
      "instructions": "刑務所から逃げ出す唯一の成功方法を見つけなさい。コンピューターマウスでゲームを操作します。モバイルデバイスをお持ちであれば、スタイラスや指を使用してください。",
      "genres": [
        "アドベンチャー"
      ],
      "tags": [
        "脱出",
        "ポイント＆クリック",
        "スティックマン",
        "物語"
      ]
    },
    "ko": {
      "title": "스틱맨 감옥과 사랑",
      "description": "Stickman Prison and Love에서는 사랑을 위해 용감한 털이기를 한 후, Stickman을 감옥에서 탈출시켜 주세요! 연인으로부터 온 미스터리한 팩지를 받아서, 그의 탈출을 계획하기 위해 신중하게 도구를 선택하세요. 모든 결정이 이 이야기 주도형 모험의 전개를 결정합니다—Stickman이 진정한 사랑과 재회할 수 있을까요?",
      "instructions": "범죄소로부터 단 하나의 성공적인 탈출 방법을 찾아보세요. 컴퓨터 마우스로 게임을 조작하세요. 모바일 기기를 사용한다면 펜슬이나 손가락을 사용하세요.",
      "genres": [
        "모험"
      ],
      "tags": [
        "탈출",
        "포인트앤클릭",
        "스틱맨",
        "이야기"
      ]
    },
    "fr": {
      "title": "Homme-en-BOIS Prison et Amour",
      "description": "Dans Stickman Prison et Amour, aidez Stickman à s'échapper de prison après un braquage audacieux pour l'amour ! Avec un colis mystérieux de sa bien-aimée, choisissez soigneusement vos outils pour planifier son évasion. Chaque décision façonne les retournements de cette aventure guidée par le récit — peut Stickman se réunir avec sa véritable amour ?",
      "instructions": "Trouvez un seul moyen réussi pour s'échapper de prison. Utilisez une souris pour contrôler le jeu. Si vous avez un appareil mobile, utilisez un stylet ou un doigt.",
      "genres": [
        "Aventure"
      ],
      "tags": [
        "échappée",
        "clic et pointe",
        "stickman",
        "histoire"
      ]
    }
  }
};
